import React from 'react';
import styles from './Contact.module.css';

function Contact() {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.badge}>Contatos</span>
                <h2>Entre em contato para assinar</h2>
                <p>Escolha um dos nossos canais de atendimento direto abaixo e fale com nossa equipe Comercial para ativar a sua conta.</p>
            </div>

            <div className={styles.content}>
                {/* Card WhatsApp - Canal Principal */}
                <div className={styles.primaryCard}>
                    <div className={styles.cardHeader}>
                        <div className={styles.iconBoxWhatsapp}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                            </svg>
                        </div>
                        <div>
                            <span className={styles.fastBadge}>Atendimento Rápido</span>
                            <h3>WhatsApp Comercial</h3>
                        </div>
                    </div>
                    <p>Converse em tempo real com um consultor, tire dúvidas sobre os planos e ative seu acesso na hora.</p>
                    <a 
                        href="https://wa.me/5531996010518?text=Olá!%20Gostaria%20de%20assinar%20um%20plano." 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className={styles.whatsappBtn}
                    >
                        Chamar no WhatsApp
                    </a>
                </div>

                {/* Card E-mail */}
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.iconBoxEmail}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                <polyline points="22,6 12,13 2,6"></polyline>
                            </svg>
                        </div>
                        <div>
                            <h3>E-mail</h3>
                        </div>
                    </div>
                    <p>Prefere propostas formais ou personalizadas? Envie um e-mail para a nossa equipe de planos.</p>
                    <a href="mailto:reprobird@gmail.com.com?subject=Solicitação%20de%20Assinatura%20de%20Plano" className={styles.emailBtn}>
                        reprobird@gmail.com
                    </a>
                </div>

                {/* Card Redes Sociais */}
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.iconBoxSocial}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="18" cy="5" r="3"></circle>
                                <circle cx="6" cy="12" r="3"></circle>
                                <circle cx="18" cy="19" r="3"></circle>
                                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                            </svg>
                        </div>
                        <div>
                            <h3>Redes Sociais</h3>
                        </div>
                    </div>
                    <p>Acompanhe novidades, recursos do sistema e entre em contato via Direct ou mensagem privada.</p>
                    
                    <div className={styles.socialButtons}>
                        <a href="https://instagram.com/repro_bird?dlrf=MW14c3RibGFwY2gydQ%3D%3D" target="_blank" rel="noopener noreferrer" className={styles.socialLink}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                            </svg>
                            Instagram
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;